import axios from 'axios'

const BaseUrl = `${process.env.REACT_APP_APIGEE_ORIGIN}/`

export const datalinkPublicApi = axios.create({
  baseURL: BaseUrl
})
